import React, { memo, Fragment, useState, useEffect } from "react";
import SectionSlider from "./Components/Slider/SectionSlider";
import TopTenCard from "./Components/Cards/TopTenCard";
import { useSelector } from "react-redux";

const  TopTrendingEpisodes = memo(({ data, isRegisterPage }) => {
  const [title, setTitle] = useState("");
  const [shows, setShows] = useState([]);
  let count = 0;
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  useEffect(() => {
    setShows(data?.shows)
    setTitle(data?.category_name)
   
  }, [data]);
  const thumbnail = data?.thumbnail_orientation ? data?.thumbnail_orientation : projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;
  return (
    <Fragment>  
    {thumbnail=== "PORTRAIT" ? <SectionSlider title={title} list={shows} className="top-ten-block" data={data} thumbnail={thumbnail} slidesPerView={5} visibleItemsCount={data?.visible_items_count} isRegisterPage={isRegisterPage} role="region" aria-label="Top Trending Episodes Portrait Section">
      {(shows) => {
        const link = shows?.video_id ?(`/videos/${shows?.vanity_url}`):(`/show-details/${shows?.vanity_url}`);   
        count += 1;
        return (
          <TopTenCard
            imagePath={shows.logo}
            countValue={count}
            link={link}
            state={{ videoDetails:shows }}
            thumbnail={thumbnail}
            isRegisterPage={isRegisterPage}
          />
        )
      }}
    </SectionSlider>
    :
    <SectionSlider title={title} list={shows} className="top-ten-block" data={data} slidesPerView={5} visibleItemsCount={data?.visible_items_count} styleElement={false} thumbnail={thumbnail} isRegisterPage={isRegisterPage} role="region" aria-label="Top Trending Episodes Landscape Section">
      {(shows) => {
        const link = shows?.video_id ?(`/videos/${shows?.vanity_url}`):(`/show-details/${shows?.vanity_url}`);   
        count += 1;
        return (
          <TopTenCard
            imagePath={shows.logo_thumb}
            portraitImagePath={isRegisterPage ? shows.logo : undefined}
            countValue={count}
            link={link}
            state={{ videoDetails:shows }}
            isRegisterPage={isRegisterPage}
          />
        )
      }}
    </SectionSlider>
    }
  </Fragment>
  );
});

TopTrendingEpisodes.displayName = " TopTrendingEpisodes";
export default  TopTrendingEpisodes;

